var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"containerDOM",staticClass:"summary-panel"},[_c('iframe',{attrs:{"src":"https://rtspproxy1.varadisecloud.com:8088/cam101.html"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }